module.exports = __webpack_public_path__ + "img/085.535f08d1.png";